import React, { Component } from 'react';
import PageSection from './PageSection';

class ThankYou extends Component {
    constructor(props) {
		super(props);
    }

    render() {
        return (
            <PageSection className={"pp-thank-you " + (this.props.className ? this.props.className : '')}>
                {this.props.icon &&
                    <img src={this.props.icon} className="pp-thank-you-logo" />
                }
                {this.props.title &&
                    <h2 className="pp-thank-you-title">{this.props.title}</h2>
                }
                {this.props.message &&
                    <p className="pp-thank-you-message">{this.props.message}</p>
                }
            </PageSection>
        );
    }
}

export default ThankYou;



// WEBPACK FOOTER //
// ./src/components/ThankYou.js